/* 
 * Export component file to be used on project
*/

import Toast from './Toast';
export default Toast;